import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from '@angular/material/snack-bar';

/**
 * Snackbar content for the "a new version is available" prompt.
 *
 * Deliberately logic-free: VersionWatcherService owns every decision and
 * simply subscribes to these two outputs. MatSnackBar.open() supports only
 * one action button, which is why this is opened via openFromComponent().
 */
@Component({
  selector: 'app-version-update-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel],
  styleUrl: './version-update-banner.component.scss',
  template: `
    <div class="banner">
      <section
        class="title"
        matSnackBarLabel
      >
        A new version of the app is available. Please refresh the page.
      </section>
      <section
        class="actions"
        matSnackBarActions
      >
        <button
          mat-button
          matSnackBarAction
          (click)="reload.emit()"
        >
          Reload now
        </button>
        <button
          mat-button
          color="warn"
          matSnackBarAction
          (click)="remindLater.emit()"
        >
          Remind me later
        </button>
      </section>
    </div>
  `,
})
export class VersionUpdateBannerComponent {
  readonly reload = output<void>();
  readonly remindLater = output<void>();
}
